import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import useImageList from './useImageList';
import { KEY } from './UpSelectBtn';
import Pubsub from '../../utils/pubsub';
import { isFullScreen, requestFullScreen } from '../../utils/dom';
import useFullScreen from './useFullScreen';
import useKeyboardControl from './useKeyboardControl';
import useMouseControl from './useMouseControl';
import RootStore from '../../store/RootStore';
import { IOneGalleryBase } from '../GalleryList/Common';

export const playOrder = [
  {
    key: 'asc',
    name: '顺序播放'
  },
  {
    key: 'random',
    name: '随机播放'
  }
];

export const playTime = [
  {
    key: 3000,
    name: '3S'
  },
  {
    key: 5000,
    name: '5S'
  },
  {
    key: 10000,
    name: '10S'
  },
  {
    key: 15000,
    name: '15S'
  },
  {
    key: 20000,
    name: '20S'
  }
];

interface IUseCarousel {
  rootStore?: RootStore;
  list: IOneGalleryBase[];
  loadMore?: () => void;
  index: number;
  setIndex: Dispatch<SetStateAction<number>>;
}
export default function(props: IUseCarousel) {
  const { list, rootStore, setIndex, index, loadMore } = props;

  const [config, setConfig] = useState({
    time: playTime[1].key, // 默认3秒
    order: playOrder[0].key,
    effect: 'random',
    danmuku: 0,
    qrcode: 0
  });

  const [start, setStart] = useState(false);
  const [opShow, setOpShow] = useState(true); // 是否显示操作

  const setTheConfig = function(key: string, value: KEY) {
    setConfig(cfg => {
      return {
        ...cfg,
        [key]: value
      };
    });
  };

  const timer = useRef(0);
  const { time } = config;
  const LOAD_PREPARE = 5;
  useEffect(() => {
    if (!start || !time) {
      return;
    }
    timer.current = window.setInterval(() => {
      setIndex(i => {
        //console.log(i, 'current index');
        // 当剩余图片数量小于LOAD_PREPARE个时，准备加载下一个
        if (list.length && i + LOAD_PREPARE > list.length) {
          console.log(
            'prepare to load more... (check if you defined loadMore)'
          );
          loadMore?.();
        }
        return (i + 1) % list.length;
      });
    }, time);
    return () => clearInterval(timer.current);
  }, [time, list, start]);

  const subToken = useRef('');
  useEffect(() => {
    subToken.current = Pubsub.subscribe('modify-before-current-index', function(
      topic: string,
      num: number
    ) {
      console.log(num);
      setIndex(i => i + num);
    });
    return () => Pubsub.unsubscribe(subToken.current);
  }, []);

  const toPlay = function() {
    rootStore?.uiStore.showToast({
      content: '点击空格键暂停/播放',
      time: 3000
    });
    setStart(true);
    setOpShow(false);
    requestFullScreen();
  };

  const toPause = ()=>{
    setStart(false);
    setOpShow(true);
  };

  // 全屏相关逻辑，移出去了
  const fullScreenChange = function() {
    const full = isFullScreen();
    if (!full) {
      setStart(false);
      setOpShow(true);
    }
  };
  useFullScreen({ fullScreenChange });

  // 键盘按键处理，目前只有空格键
  const spacePress = function(i: number) {
    // 全屏下才生效
    if (isFullScreen()) {
      setStart(s => !s);
    }
  };
  useKeyboardControl({
    spacePress,
    index
  });

  // 鼠标事件
  const inFunc = function() {
    isFullScreen() && setOpShow(true);
  };
  const outFunc = function() {
    isFullScreen() && setOpShow(false);
  };
  useMouseControl({
    inFunc,
    outFunc
  });

  // const finalList =
  //   config.order === 'random'
  //     ? // 注意,sort是原地排序的，不能直接在list上使用
  //       [...list].sort(function() {
  //         return Math.random() - Math.random();
  //       })
  //     : list;

  const [finalList, setFinalList] = useState([] as IOneGalleryBase[]);
  useEffect(()=>{
    if(config && config.order == 'random') {
      setFinalList([...list].sort(function() {
        return Math.random() - Math.random();
      }));
    }else {
      setFinalList(list);
    }
  }, [list, config]);

  return {
    start,
    config,
    finalList,
    opShow,
    list,
    setTheConfig,
    toPlay,
    toPause
  };
}
